export default __webpack_public_path__ + "static/InsightInspirationStoryTwo-daf288eef6cb4a569fc154ed672bda61.webp";